import React from 'react';

import { Row, Col } from 'react-bootstrap5';

import { useContext as useUsersContext } from 'components/Users/Context';

import { Link } from 'react-router-dom';
import routes from 'app/routes';
import Card from './Card';
import Age from './Age';
import Email from './Email';
import Gender from './Gender';
import Location from './Location';
import Phone from './Phone';
import TimeZone from './TimeZone';
import Password from './Password';

import Languages from './Languages';

import Industry from './Industry';
import YearExperience from './YearExperience';
import CareerLevel from './CareerLevel';
import HireDate from './HireDate';
import Team from './Team';
import EmploymentType from './EmploymentType';
import Tenure from './Tenure';
import LastPromotion from './LastPromotion';
import TypePromotion from './TypePromotion';

export default function Index() {
  const { state: stateUsers } = useUsersContext();

  const member = stateUsers.user.attributes.specific;

  return (
    <div className="pt-2 user-profile">

      <Row>
        <Col lg={6} className="mb-5">
          <div className="d-flex justify-content-between mt-3">
            <div className="block-title">Member</div>
            <Link
              to={routes.members.profile.general}
              className="btn btn-link"
            >
              Edit
            </Link>
          </div>

          <Card member={member} />

          <div className="d-flex justify-content-between mt-5">
            <div className="block-title">Basic Info</div>
            <Link
              to={routes.members.profile.basic}
              className="btn btn-link"
            >
              Edit
            </Link>
          </div>

          <Gender member={member} />
          <Age member={member} />
          <Email member={member} />
          <Phone member={member} />
          <Location member={member} />
          <TimeZone member={member} />
          <Password />

        </Col>

        <Col lg={6} className="mb-5">

          <div className="d-flex justify-content-between mt-3">
            <div className="block-title">Languages</div>
            <Link
              to={routes.members.profile.languages}
              className="btn btn-link"
            >
              Edit
            </Link>
          </div>

          <Languages member={member} />

          <div className="d-flex justify-content-between mt-5">
            <div className="block-title">Experience</div>
            <Link
              to={routes.members.profile.experience}
              className="btn btn-link"
            >
              Edit
            </Link>
          </div>

          <Industry member={member} />
          <YearExperience member={member} />
          <CareerLevel member={member} />
          <HireDate member={member} />
          <Team member={member} />
          <EmploymentType member={member} />

          <div className="d-flex justify-content-between mt-5">
            <div className="block-title">Career History</div>
            <Link
              to={routes.members.profile.career_history}
              className="btn btn-link"
            >
              Edit
            </Link>
          </div>

          <Tenure member={member} />
          <LastPromotion member={member} />
          <TypePromotion member={member} />

        </Col>
      </Row>

    </div>
  );
}
